import MJournalCard from './MJournalCard.vue';

export { MJournalCard };
export default MJournalCard;
